import React from 'react';
import { Link } from 'react-router-dom';

// Add responsive footer styles
const footerStyles = `
  .footer {
    background-color: #1e1e1e;
    color: white;
    padding: 1.5rem 1rem;
    margin-top: auto;
  }
  
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }
  
  .footer-disclaimer h3 {
    font-size: 1.1rem;
    margin-top: 0;
    margin-bottom: 0.75rem;
  }
  
  .footer-disclaimer p {
    font-size: 0.9rem;
    line-height: 1.5;
    margin: 0;
  }
  
  .footer-links {
    margin-top: 1.5rem;
  }
  
  .footer-links-list {
    list-style: none;
    padding: 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin: 0;
  }
  
  .footer-link {
    color: white;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s;
  }
  
  .footer-link:hover {
    color: #7FE7D9;
  }
  
  .footer-copyright {
    text-align: center;
    margin-top: 1.5rem;
    font-size: 0.85rem;
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    .footer {
      padding: 1.25rem 1rem;
    }
    
    .footer-links-list {
      gap: 1rem;
    }
  }
  
  @media (max-width: 480px) {
    .footer-links-list {
      flex-direction: column;
      align-items: center;
      gap: 0.75rem;
    }
    
    .footer-disclaimer h3 {
      text-align: center;
    }
  }
`;

const Footer: React.FC = () => {
  return (
    <>
      <style>{footerStyles}</style>
      <footer className="footer">
        <div className="footer-container">
          {/* Disclaimer moved to a separate page */}
          <div className="footer-links">
            <ul className="footer-links-list">
              <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="footer-link">Terms of Service</Link></li>
              <li><Link to="/disclaimer" className="footer-link">Disclaimer</Link></li>
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/affiliate-program" className="footer-link">Affiliate Program</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          <p>Copyright © 2025 AskCEO.ai</p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
